const preloader = {

  data() {
    return {
      loadedCount: 0,
      imagesArray: [],
      tempArr    : [],
      callBack   : null
    }
  },

  methods: {
    preloadImages(imgArr, cb) {
      this.imagesArray = imgArr;
      this.callBack    = cb;
      for (let i = 0; i < imgArr.length; i++) {
        this.tempArr[i] = new Image();
        this.tempArr[i].addEventListener('load', this.imagesLoaded);
        this.tempArr[i].src = imgArr[i];
      }
    },
    // This is fired with each image that loads.
    imagesLoaded(e) {
      // Use loadedCount to keep track of images
      // console.log('imagesLoaded');
      // console.log(e);
      e.target.removeEventListener('load', this.imagesLoaded);
      this.loadedCount++;
      if (this.loadedCount >= this.imagesArray.length) {
        this.callBack(this.tempArr);
      }
    },
  }


}

export default preloader;
